import React, {Fragment, useState, useEffect} from 'react';
import {Button, Modal, Form, Input, Select, notification, Row, Col} from 'antd';
import {t} from 'utils/i18n';
import {onChangeInput, onBlurInput, beforSubmit} from 'utils/Logics';
import {debound} from 'utils';
import {searchDatas} from 'apis/datas';
import {trainModel} from 'apis/models';
import {LABELS} from 'consts';
import {getListProjects} from 'apis/projects';

const RegessionTab = (props) => {


  
  return (
    <>
      <Form>
        <Form.Item label={t("Project")}>
          
          <Select
            value={props.project}
            onChange={(value) => props.setProject(value)}
            className="fullsize_selectbox"
            showSearch
            loading={props.loading}
            placeholder={t("Search project by name...")}
            onSearch={debound(props._onSearchProject, 500)}
            defaultActiveFirstOption={false}
            filterOption={false}
            notFoundContent={null}
            onPopupScroll={props.handleScroll}
          >
            {
              
              props.projects.map(p => (
                <Select.Option value={p.project_id} key={p.project_id}>{`${p.name}`}</Select.Option>
              ))
            }
          </Select>
        </Form.Item>
        <Form.Item label={t("Model Name")} required help={props.message.name}>
          <Input
            value={props.models.name}
            onChange={onChangeInput(props._setFieldModels("name"), props._setMessage("name"))}
            onBlur={onBlurInput(props.models.name, props._setMessage("name"), "Model name")}
            maxLength={100}
          />
        </Form.Item>
      </Form>
      <strong>{t("Training data")}</strong>
      <Row gutter={[8, 0]}>
        <Col span={6}>
          <Form>
            <Form.Item label={t("Label")}>
              <Select
                value={props.label}
                onChange={(value) => props.setLabel(value)}
                className="fullsize_selectbox"
              >
                {
                  Object.values(LABELS).map(label => (
                    <Select.Option value={label} key={label}>{`${t(label)}`}</Select.Option>
                  ))
                }
              </Select>
            </Form.Item>
          </Form>
        </Col>
        <Col span={18}>
          <Form>
            <Form.Item label={t("Data name")} required help={props.message.data_ids}>
              <Select
                // mode="multiple"
                placeholder={t("Search data by name...")}
                showSearch
                value={props.models.data_ids && props.models.data_ids[0]}
                onSearch={debound(props._onSearch, 500)}
                defaultActiveFirstOption={false}
                filterOption={false}
                notFoundContent={null}
                onChange={props._onChangeDataName}
              >
                {
                  props.datas.map(d => (
                    <Select.Option value={d.data_id} key={d.data_id}>{`${d.name}`}</Select.Option>
                  ))
                }
              </Select>
            </Form.Item>
          </Form>
        </Col>
      </Row>
    </>
  )
}

export default RegessionTab